import { message, notification } from 'antd'

const noop = () => {}

// Persistent visually-hidden live region for screen reader announcements.
// Must be in the DOM before any announcements are made — eagerly initialized.
const liveRegionEl = document.createElement('div')
liveRegionEl.setAttribute('aria-live', 'polite')
liveRegionEl.setAttribute('aria-atomic', 'true')
liveRegionEl.style.cssText =
  'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0'

if (document.body) {
  document.body.appendChild(liveRegionEl)
} else {
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(liveRegionEl))
}

const announce = text => {
  liveRegionEl.textContent = ''
  // Delay past modal close animation (~300ms) so focus has settled before announcing
  setTimeout(() => {
    liveRegionEl.textContent = text
  }, 400)
}

/**
 * Shows an error notification
 * @param {Object} param
 */
const error = ({ content, duration = 3, title }) => {
  const result = notification.error({
    description: content,
    duration,
    message: title,
  })
  announce(title ? `${title}${content ? ': ' + content : ''}` : content || 'Error')
  return result
}

/**
 * Shows an info notification
 * @param {Object} param
 */
const info = ({ content, duration = 3, title }) => {
  const result = notification.info({
    description: content,
    duration,
    message: title,
  })
  announce(title ? `${title}${content ? ': ' + content : ''}` : content || 'Info')
  return result
}

/**
 * Shows a simple success message
 * @param {Object} param
 */
const success = ({ content, duration = 4, onClose = noop, top }) => {
  message.config({
    top,
  })
  const result = message.success(content, duration, onClose)
  announce(content || 'Success')
  return result
}

export default {
  error,
  info,
  success,
}
